import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

const ProtectedRoutes = () => {
    return sessionStorage.access_token ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
